import { CloseCircleOutlined } from "@ant-design/icons";
import { useTranslations } from "use-intl";
import Button from "@/shared/form/button";
import { RejectSigningModal } from "@/modules/signing/shared/ui/reject-signing-modal";
import { useRejectExternalSigningMutation } from "@/modules/gateway/features/open-external-sign/model/use-reject-external-signing-mutation";

export function RejectExternalSigningButton() {
  const t = useTranslations("ExternalSign");
  const { reject, loading } = useRejectExternalSigningMutation();

  return (
    <RejectSigningModal
      onSubmit={reject}
      loading={loading}
      trigger={(open) => (
        <Button
          danger
          icon={<CloseCircleOutlined />}
          loading={loading}
          onClick={open}
          data-testid={"reject-external-signing-button"}
        >
          {t("Reject")}
        </Button>
      )}
    />
  );
}
